var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", [
        _vm.product.dueDateManageNotChange
          ? _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _vm.product.dueDateManageFlg
                ? _c(
                    "div",
                    { staticClass: "m-t-sm" },
                    [
                      _c("date-picker", {
                        ref: "expirationDate",
                        attrs: {
                          placeholder: "",
                          format: "YYYY/MM/DD",
                          "input-attr": { class: "expiration-date" },
                          lang: _vm.lang,
                          "not-before": _vm.todayFormatDate,
                          disabled: _vm.isDisableEdit,
                          "input-class": [
                            "mx-input",
                            _vm.product.expirationDate ? "" : "bg-no-input"
                          ]
                        },
                        on: { change: _vm.updateExpirationDate },
                        model: {
                          value: _vm.product.expirationDate,
                          callback: function($$v) {
                            _vm.$set(_vm.product, "expirationDate", $$v)
                          },
                          expression: "product.expirationDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _c("div", [
              _c("div", { staticClass: "box-toggle-switch" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.dueDateManageFlg,
                      expression: "product.dueDateManageFlg"
                    }
                  ],
                  staticClass: "switch-input",
                  attrs: {
                    type: "checkbox",
                    disabled: _vm.isDisableEdit,
                    id: "due-date-manage-" + _vm.product.asin
                  },
                  domProps: {
                    checked: Array.isArray(_vm.product.dueDateManageFlg)
                      ? _vm._i(_vm.product.dueDateManageFlg, null) > -1
                      : _vm.product.dueDateManageFlg
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.product.dueDateManageFlg,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.product,
                              "dueDateManageFlg",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.product,
                              "dueDateManageFlg",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.product, "dueDateManageFlg", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "switch-label",
                  class: [{ "switch-label-gray": _vm.isDisableEdit }],
                  attrs: { for: "due-date-manage-" + _vm.product.asin },
                  on: {
                    click: function($event) {
                      _vm.updateDueDateManageFlg()
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { class: "" + _vm.getStatusItem.class }, [
                  _vm._v(_vm._s(_vm.getStatusItem.status))
                ])
              ]),
              _vm._v(" "),
              _vm.product.dueDateManageFlg
                ? _c(
                    "div",
                    { staticClass: "m-t-sm" },
                    [
                      _c("date-picker", {
                        ref: "expirationDate",
                        attrs: {
                          placeholder: "",
                          format: "YYYY/MM/DD",
                          "input-attr": { class: "expiration-date" },
                          lang: _vm.lang,
                          "not-before": _vm.todayFormatDate,
                          "input-class": [
                            "mx-input",
                            _vm.product.expirationDate ? "" : "bg-no-input"
                          ],
                          disabled: _vm.isDisableEdit
                        },
                        on: { change: _vm.updateExpirationDate },
                        model: {
                          value: _vm.product.expirationDate,
                          callback: function($$v) {
                            _vm.$set(_vm.product, "expirationDate", $$v)
                          },
                          expression: "product.expirationDate"
                        }
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "w-150 m-t-sm mx-datepicker" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: "" }
                    })
                  ])
            ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-toggle-switch" }, [
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox", checked: "true" }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "switch-label switch-label-gray" }),
      _vm._v(" "),
      _c("span", { staticClass: "text-red" }, [_vm._v("あり")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14737f26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14737f26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/DueDateManagementItem.vue
// module id = null
// module chunks = 